import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './pages/Header';
import MainSection from './pages/MainSection';
import Footer from './pages/Footer';
import ScrollToTop from './components/ScrollToTop';
import { ThemeProvider } from './context/ThemeContext';
import './assets/styles/theme.css';
import './assets/styles/accessibility.css';
import './assets/styles/Transitions.css';

// AnimatePresence requires the use of a location from useLocation hook
// So we need to create this wrapper component
const AnimatedRoutes = () => {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<MainSection />} />
        {/* <Route path="/blog" element={<Blog />} /> */}
        {/* Add more routes as needed */}
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div>
          {/* Skip to main content link for keyboard users */}
          <a href="#main-content" className="skip-link">
            Skip to main content
          </a>
          
          <Header />
          
          <main id="main-content" style={{ paddingBottom: '60px' }}>
            <AnimatedRoutes />
          </main>
          
          <Footer />
          
          {/* Add the scroll to top button */}
          <ScrollToTop showBelow={300} />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;